<template>
    <div>
        <div class="gradient-checkbox">
            <Checkbox @input="toggleBackgroundGradient" v-model="isGradient" /> Gradient
        </div>

        <div class="color-selector-wrap">
            <div class="color-selector" :style="{ background: backgroundColor }" @click="toggleColors()">
                <i :class="{ rotate: isOpened }" class="chevron icon-chevron-down"></i>
            </div>
            <div class="color-dropdown" v-show="isOpened">
                <button v-for="(color, index) in backgrounds" v-if="isGradient && color.type == 'gradient'" :key="index" @click="selectElementColor(color)" :style="{ background: color.styles }"></button>
                <button v-for="(color, index) in backgrounds" v-if="!isGradient && color.type == 'color'" :key="index" @click="selectElementColor(color)" :style="{ background: color.styles }"></button>
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from "@/components/atoms/CustomCheckbox.vue";

export default {
    name: 'BackgroundSwitcher',
    components: { Checkbox },
    data() {
        return {
            isGradient: false,
            isOpened: false
        }
    },
    computed: {
        backgroundColor() {
            return this.$store.getters.backgroundColor
        },
        backgrounds() {
            return this.$store.getters.backgrounds
        }
    },
    mounted() {
        this.updateCheckbox()
    },
    methods: {
        toggleBackgroundGradient(val) {
            const filteredColor = this.backgrounds.filter(colorObj => colorObj.styles.includes(this.backgroundColor))[0]
            const index = filteredColor.name.charAt(filteredColor.name.length - 1)
            const type = val ? 'gradient' : 'color'
            
            const colorToAdd = this.backgrounds.filter(colorObj => colorObj.type == type && colorObj.name.includes(index))[0]

            //this.$store.dispatch('setBackgroundColor', colorToAdd)
            this.$emit('color-selected', colorToAdd)
        },
        updateCheckbox() {
            if (this.backgroundColor.includes('gradient')) {
                this.isGradient = true
            } else {
                this.isGradient = false
            }
        },
        toggleColors() {
            this.isOpened = !this.isOpened;
        },
        selectElementColor(color) {
            this.isOpened = false;
            //this.$store.dispatch('setBackgroundColor', color.styles)
            //document.body.style.background = color.styles
            this.$emit('color-selected', color)
        }
    }
}
</script>

<style>
.gradient-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
}
.color-selector-wrap,
.icon-selector-wrap {
    margin-top: 7px;
    margin-bottom: 20px;
}
</style>